import { LatLng, insideCircle, distanceTo } from "geolocation-utils";

import { Iterable, IPlace } from "types";

export const searchRecreationBreakpoint = ({
  location,
  fromPlaces,
  searchRadiusInKms,
}: {
  location: LatLng;
  searchRadiusInKms: number;
  fromPlaces: Iterable<IPlace>[];
}) => {
  const circle = { lat: location.lat, lon: location.lng };

  const placesInsideCircle = fromPlaces.filter((place) => {
    const placeLocation = { lat: place.latitude, lng: place.longitude };

    const isInsideCircle = insideCircle(
      { lat: placeLocation.lat, lon: placeLocation.lng },
      circle,
      searchRadiusInKms * 1000
    );

    return isInsideCircle;
  });

  const sortedByDistance = placesInsideCircle.sort((a, b) => {
    const distanceToA = distanceTo(circle, {
      lat: a.latitude,
      lon: a.longitude,
    });

    const distanceToB = distanceTo(circle, {
      lat: b.latitude,
      lon: b.longitude,
    });

    return distanceToB - distanceToA;
  });

  return sortedByDistance.length > 0
    ? { ...sortedByDistance[0], breaktime: 16 }
    : undefined;
};
